<template>
    <ls-modal :options="modals.lawnTreatment" @onModalClose="closeModal('lawnTreatment')">
        <div slot="header">
            <h3 class="ls-align--center ls-color--green">Lawn Treatment</h3>
        </div>

        <div class="grid">
            <div class="grid__col-12">
                <p class="ls-align--center" data-font-size="-1">
                    A fertilization &amp; weed control program spread over
                    <span class="ls-nowrap">8-treatments</span>
                    <span class="ls-nowrap">throughout the year</span>
                </p>
                <hr />
                <p class="ls-italic ls-align--center ls-color--gray" data-font-size="-1">
                    Your path to a healthier, <span class="ls-nowrap">more attractive lawn!</span>
                </p>
                <hr />

                <h4 class="ls-margin--top-none">
                    <strong class="ls-uppercase">Thicker &amp; Greener Turf</strong>
                </h4>
                <p class="ls-color--gray">
                    Fertilization adds nutrients needed for plant growth back to your
                    <span class="ls-nowrap">lawn&mdash;the</span> most important being nitrogren,
                    phosphorous, potassium, and iron.
                </p>

                <h4>
                    <strong class="ls-uppercase">Fewer Weeds</strong>
                </h4>
                <p class="ls-color--gray">
                    Weed control prevents weeds from emerging year&#8209;round.
                </p>

                <h4>
                    <strong class="ls-uppercase">Improved Soil Conditions</strong>
                </h4>
                <p class="ls-color--gray">
                    Year-round treatment prevents &ldquo;burning&rdquo; of your lawn and maximizes
                    the nutrients required for each season.
                </p>
            </div>
        </div>

        <div slot="button" class="grid">
            <div class="grid__col-12">
                <div>
                    <button
                        slot="button"
                        class="ls-float-right ls-button ls-button--white"
                        type="button"
                        @click="closeModal('lawnTreatment')"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </ls-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';

export default {
    components: {
        lsModal,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['modals']),
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
        }),
    },
};
</script>

<style lang="scss" scoped>
h1 {
    margin-bottom: rem(-4);
}

h4 {
    margin-top: rem(0);
    margin-bottom: 3px;
    font-size: rem(-1);
}

p {
    font-size: rem(-1);
    margin-top: 0;
}
</style>
